import { Directive, HostListener } from '@angular/core';
import { CommonServices } from '../Common/CommonServices';

@Directive({
  selector: '[appNumbersonlyNotStartingFromZero]',
  standalone: false
})
export class NumbersonlyNotStartingFromZeroDirective {
  private digitRegex: RegExp = /^[0-9]+$/;

  constructor(private commonServices: CommonServices) {}

  // ================= KEYPRESS =================
  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {

    const inputChar = String.fromCharCode(event.charCode);
    const inputElement = event.target as HTMLInputElement;

    // Block non-numeric
    if (!this.digitRegex.test(inputChar)) {
      event.preventDefault();
      this.commonServices.showMessage('error', 'Numbers only', 2);
      return;
    }

    // Block starting with 0
    if (inputElement.value.length === 0 && inputChar === '0') {
      event.preventDefault();
      this.commonServices.showMessage('error', 'Cannot start with 0', 2);
      return;
    }
  }

  // ================= PASTE =================
  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {

    const pastedText = event.clipboardData?.getData('text') || '';
    const inputElement = event.target as HTMLInputElement;

    // Block non-numeric paste
    if (!this.digitRegex.test(pastedText)) {
      event.preventDefault();
      this.commonServices.showMessage('error', 'Pasted content must be numbers only', 2);
      return;
    }

    // Block paste starting with 0 (if empty)
    if (inputElement.value.length === 0 && pastedText.startsWith('0')) {
      event.preventDefault();
      this.commonServices.showMessage('error', 'Cannot start with 0', 2);
      return;
    }
  }
}
